import { render } from "./StepsCard.vue?vue&type=template&id=a8309c8e&lang=pug"
import script from "./StepsCard.vue?vue&type=script&lang=js"
export * from "./StepsCard.vue?vue&type=script&lang=js"

import "./StepsCard.vue?vue&type=style&index=0&id=a8309c8e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__